import { render } from "./TContratoEditar.vue?vue&type=template&id=2bb8acf4"
import script from "./TContratoEditar.vue?vue&type=script&lang=js"
export * from "./TContratoEditar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__